import { render, staticRenderFns } from "./NormalSearchNav189.vue?vue&type=template&id=12acabf8&scoped=true&"
import script from "./NormalSearchNav189.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav189.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12acabf8",
  null
  
)

export default component.exports